import { atom } from "recoil";

export const languageState = atom({
  key: "languageState",
  default: navigator.language.substring(0, 2),
});